
export default () => ({
  isLoading: false,
  form: {
    filialId: null,
    country: {
      slug: null,
      name: null,
      badge: null
    },
    city: {
      slug: null,
      name: null,
      badge: null
    },
    startDate: null,
    rooms: [
      {
        adults: 2,
        children: 0,
        ages: []
      }
    ],
    budget: null,
    name: null,
    surname: null,
    email: null,
    phone: null,
    comment: null,
  },
  filials: []
})
